<script setup>
import { TabsTrigger } from "reka-ui";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  value: { type: String, required: true },
  disabled: { type: Boolean, default: undefined },
  class: { type: String, default: undefined },
});
</script>

<template>
  <TabsTrigger
    data-slot="tabs-trigger"
    :value="props.value"
    :disabled="props.disabled"
    :class="
      cn(
        'data-[state=active]:bg-background data-[state=active]:text-foreground text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 inline-flex  items-center justify-center gap-1.5 whitespace-nowrap rounded-md px-2 py-1 text-sm font-medium transition-[color,box-shadow] focus-visible:outline-1 focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 data-[state=active]:shadow-sm [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg]:w-4 [&_svg]:h-4',
        props.class
      )
    "
    style="height: 30px"
  >
    <slot />
  </TabsTrigger>
</template>
